import {getStaticInfo} from '@/utils/auth.js'
import {
    StaticIndexConfig
  } from '@/const/StaticIndexConfig.js'
import {formatDate} from '@/utils/format.js'
const GetStaticIndexMixin = {
  data() {
    return {
      StaticIndexs: [],
      configsName:{},
      level1:'',
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    formatTime(timeStr){
      var date = new Date(timeStr)
      var time = formatDate(date,"yyyy/MM/dd")
      return time
    },
    initData(level1){
      this.level1 = level1
      //设置名字
      let configs = StaticIndexConfig
      for(var cfg of configs){
       if(cfg.value===this.level1){
          this.configsName[cfg.value] = cfg.label
          for (var lv2cfg of cfg.children){
            this.configsName[lv2cfg.value] = lv2cfg.label
          }
          break
       }
      }
      //设置数据
      let data = getStaticInfo()
      for (var item of data){
        if(item.level1===this.level1){
          if(this.StaticIndexs[item.level2]){
            this.StaticIndexs[item.level2].push(item)
          }else{
            this.StaticIndexs[item.level2] = [item]
          }
        }
      }
    },
  }
}

export default GetStaticIndexMixin
